import { fetchCurrentUser } from '../../ducks/user.duck';
import { onGroupFolderDocumentCollectionCreate } from '../../util/api';
import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';
import { fetchSpaceList, getSpaceDetails, toggleCreateComment } from '../CircleCommunityPage/CircleCommunityPage.duck';
import { fetchGroupFolder } from '../MyGroupCommunityPage/MyGroupCommunityPage.duck';

export const REQUEST_SPACE_DETAILS = 'app/DiscoverGroupPage/REQUEST_SPACE_DETAILS';
export const SUCCESS_SPACE_DETAILS = 'app/DiscoverGroupPage/SUCCESS_SPACE_DETAILS';
export const ERROR_SPACE_DETAILS = 'app/DiscoverGroupPage/ERROR_SPACE_DETAILS';

export const REQUEST_UPDATE_DOCUMENT = 'app/DiscoverGroupPage/REQUEST_UPDATE_DOCUMENT';
export const SUCCESS_UPDATE_DOCUMENT = 'app/DiscoverGroupPage/SUCCESS_UPDATE_DOCUMENT';
export const ERROR_UPDATE_DOCUMENT = 'app/DiscoverGroupPage/ERROR_UPDATE_DOCUMENT';

const initialState = {
  requestSpaceDetails: false,
  spaceDetailsData: null,
  errorSpaceDetails: null,

  updateDocumentInProgress: false,
  documnetUpdated: null,
  updateDocumentError: null,
};

export default function DiscoverGroupPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_SPACE_DETAILS:
      return { ...state, requestSpaceDetails: true };
    case SUCCESS_SPACE_DETAILS:
      return { ...state, requestSpaceDetails: false, spaceDetailsData: payload.data };
    case ERROR_SPACE_DETAILS:
      return {
        ...state,
        requestSpaceDetails: false,
        spaceDetailsData: null,
        errorSpaceDetails: payload.error,
      };

    case REQUEST_UPDATE_DOCUMENT:
      return { ...state, updateDocumentInProgress: true };
    case SUCCESS_UPDATE_DOCUMENT:
      return { ...state, updateDocumentInProgress: false, documnetUpdated: payload.data };
    case ERROR_UPDATE_DOCUMENT:
      return {
        ...state,
        updateDocumentInProgress: false,
        documnetUpdated: null,
        updateDocumentError: payload.error,
      };

    default:
      return state;
  }
}

export const requestSpaceDetails = () => ({
  type: REQUEST_SPACE_DETAILS,
});
export const successSpaceDetails = data => ({
  type: SUCCESS_SPACE_DETAILS,
  payload: { data },
});
export const errorSpaceDetails = error => ({
  type: ERROR_SPACE_DETAILS,
  payload: { error },
});

export const requestUpdateDocument = () => ({
  type: REQUEST_UPDATE_DOCUMENT,
});
export const successUpdateDocument = data => ({
  type: SUCCESS_UPDATE_DOCUMENT,
  payload: { data },
});
export const errorUpdateDocument = error => ({
  type: ERROR_UPDATE_DOCUMENT,
  payload: { error },
});

export const uploadDocumentInMongo = params => (dispatch, getState) => {
  dispatch(requestUpdateDocument());
  return onGroupFolderDocumentCollectionCreate({ payload: params }).then((res) => {
    dispatch(successUpdateDocument(res));
    return res;
  })
    .catch((error) => {
      dispatch(errorUpdateDocument(storableError(error)));
    })
};

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  const { page = 1, sort = 'latest', topicId = null } = parse(search);

  const { currentUser } = getState().user;
  const { spaceListData } = getState().CircleCommunityPage;
  try {
    if (!currentUser) {
      await dispatch(fetchCurrentUser());
    }
  } catch (e) {
    console.log(e, '&&& &&& => e');
  }

  const promisify = [dispatch(getSpaceDetails({ spaceId: params.id, page: +page, sort, topicId : topicId })), dispatch(toggleCreateComment(false)),
     dispatch(fetchGroupFolder({
        payload: {
          groupId: params.id,
          isActive: true,
          isDelete: false
        }
      }))
  ];

  if (!spaceListData || (spaceListData && spaceListData.length == 0)) promisify.push(dispatch(fetchSpaceList()));

  return Promise.all(promisify);
};
